export const styles = {
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  tableHeader: {
    color: '#707087',
    fontSize: 14,
  },
  square: {
    height: 40,
    width: '100%',
  },
  wrapperSquare: {
    padding: '6px 14px',
  },
  headerSubTable: {
    width: '16%',
  },
  headerSubTableFirstRow: {
    width: 120,
  },
  link: {
    color: '#004360',
    textDecoration: 'underline',
    fontWeight: 600,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  distanceRed: {
    color: '#00112B',
    padding: '2px 10px',
    borderRadius: '10px',
    background: '#FFC1CB',
  },
  distanceYellow: {
    color: '#00112B',
    padding: '2px 10px',
    borderRadius: '10px',
    background: '#FFF384',
  },
  distanceYellowGreen: {
    color: '#00112B',
    padding: '2px 10px',
    borderRadius: '10px',
    background: '#DEF665',
  },
  distanceGreen: {
    color: '#00112B',
    padding: '2px 10px',
    borderRadius: '10px',
    background: '#AEF665',
  },
  distanceFullGreen: {
    color: '#00112B',
    padding: '2px 10px',
    borderRadius: '10px',
    background: '#65F67C',
  },
  distanceNot: {
    padding: '2px 10px',
    borderRadius: '10px',
    background: '#00112B',
    color: '#FFFFFF',
  },
  isNoticePeriod: {
    background: '#FBD2D98F',
  },
  isNoticePeriodIcon: {
    position: 'absolute',
    top: '31%',
    right: '-4px',
  },
  relative: {
    position: 'relative',
  },
}
